
import React from 'react';
import PaymentForm from '@/components/payment/PaymentForm';
import { calculateGrossFromNetSync } from '@/utils/fees';
import { GrossCalculationResult } from '@/utils/fees/calculators/grossAmountCalculator';
import { getAmountDueToday } from '@/utils/payment/paymentCalculations';

interface CheckoutSectionProps {
  selectedProductIds: string[];
  selectedProducts: any[];
  primaryProduct: any;
  externalUserId?: string;
  externalProductId?: string;
}

const CheckoutSection: React.FC<CheckoutSectionProps> = ({
  selectedProductIds,
  selectedProducts,
  primaryProduct,
  externalUserId,
  externalProductId
}) => {
  // If no products are selected, show a message
  if (selectedProductIds.length === 0) {
    return (
      <div className="border border-[color:hsl(var(--color-warning))/30] bg-[color:hsl(var(--color-warning))/10] rounded-lg p-4 text-[color:hsl(var(--color-warning))/90]">
        <h3 className="font-medium mb-2">No Products Selected</h3>
        <p className="text-sm">Please select at least one product to proceed with checkout.</p>
      </div>
    );
  }

  // Calculate gross amount for the payment form
  const calculateGross = (): GrossCalculationResult => {
    const totalNetAmount = selectedProducts.reduce(
      (total, product) => total + getAmountDueToday(product),
      0
    );
    
    // Use the fee calculator to determine the gross amount and fees
    const paymentMethod = 'card'; // Default to card for initial calculation
    // Use the synchronous version instead of the async version
    const result = calculateGrossFromNetSync(totalNetAmount, paymentMethod);
    
    return {
      netAmount: totalNetAmount,
      grossAmount: result.grossAmount,
      stripeFee: result.stripeFee,
      keepMoreFee: result.keepMoreFee,
      applicationFee: result.keepMoreFee, // Application fee equals keepMoreFee
      totalFees: result.stripeFee + result.keepMoreFee,
      raw: {
        netAmountCents: Math.round(totalNetAmount * 100),
        grossAmountCents: Math.round(result.grossAmount * 100),
        stripeFeeCents: Math.round(result.stripeFee * 100),
        keepMoreFeeCents: Math.round(result.keepMoreFee * 100),
        applicationFeeCents: Math.round(result.keepMoreFee * 100)
      }
    };
  };

  const grossCalculation = calculateGross();

  return (
    <div>
      {/* Payment form with integrated order summary */}
      <PaymentForm 
        product={primaryProduct} 
        additionalProducts={selectedProducts.length > 1 ? selectedProducts.slice(1) : []}
        country="US"
        region="CA"
        grossCalculation={grossCalculation}
        externalUserId={externalUserId}
        externalProductId={externalProductId}
      />
    </div>
  );
};

export default CheckoutSection;